import React from "react";

const BlogHome = () => {
  return (
    <div className="px-[5%] flex justify-evenly md:flex-row flex-col pt-[30%] md:pt-[10%] pb-[3%] bg-[#83c0fc]">
      <div className=" md:w-[60%] ">
        <p className="type-eyebrow text-[#FFDB16]">
          MANAGED BLOG SERVICES
        </p>
        <h1 className="type-page-title text-[#FCFCFD] text-left md:w-[700px]">
          Expert MY COMPANY BLOGS to get your website ranked across top search
          engines.
        </h1>
        <p className="type-body-large text-[#EEF2F6] text-left md:w-[524px] my-[10px]">
          Grow leads for your business by using recommended BLOG strategies that
          will help your audience discover your website more easily.
        </p>
      </div>
      <div className="mt-[2%]  md:w-[40%]">
        <img src="/Images/blog1.svg" alt="" />
      </div>
    </div>
  );
};

export default BlogHome;
